import { key, t_key } from 'core-ts-types';
import * as _4 from 'lodash4';

type SectionRegistrationAttributesRenderType = 'dropdown' | 'text' | 'range' | 'combobox';

interface ISectionRegistrationAttributeOption {
  title: string;
  value: string;
}

export class SectionRegistrationAttribute {
  id: number;
  is_active: boolean;
  options: ISectionRegistrationAttributeOption[];
  initial_value?: number | string | Date | null;
  render_type: SectionRegistrationAttributesRenderType;
  section: number;
  title: string;
  name: string;
  required: boolean;
}

export class SectionRegistrationAttributes {
  static build(registrationAttributes: SectionRegistrationAttributes) {
    return new SectionRegistrationAttributes(registrationAttributes);
  }

  id: number; // sectionID
  attributes: SectionRegistrationAttribute[];
  constructor(registrationAttributes: SectionRegistrationAttributes) {
    _4.merge(this, registrationAttributes);
    return this;
  }
}

export interface IRegFormOutput {
  auxiliary_attributes_by_section?: Record<string, any>;
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/registration_attributes/builders/section_registraion_attributes_builder.ts